import React from 'react';
import './style.scss';
import SettingsIcon from '@material-ui/icons/Settings';
import { I18n } from 'react-redux-i18n';
import { history } from '../../store';

// CTA lien (roue crantée + libellé) affiché dans le header global (App.js).
// Point d'entrée de navigation vers la page de réglages pleine page (/settings).
const SettingsLink = () => {
	const open = () => {
		history.push('/settings');
		window.scrollTo(0, 0);
	};

	return (
		<button type="button" className="header-settings-link" onClick={open}>
			<SettingsIcon />
			<span>{I18n.t('settings.title')}</span>
		</button>
	);
};

export default SettingsLink;
